export class ExternalUsers {
    UserId: number;
    ExternalUserIdType: string;
    ExternalUserId: string;
}
